import React, {useEffect, useState, useRef} from 'react'
import {useIntl} from 'react-intl'
import {Box, Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import TopArrowIcon from './TopArrow'

const ScrollToTop = () => {
    const [showScrollTop, setShowScrollTop] = useState(false)
    const intl = useIntl()
    const srRef = useRef(null)

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 300)
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        showScrollTop && (
            <Flex className="scroll-top">
                <Box
                    className="scroll-icon"
                    style={{
                        position: 'fixed',
                        bottom: '65px',
                        right: '10px',
                        cursor: 'pointer',
                        zIndex: 1
                    }}
                >
                    <Flex
                        as="button"
                        onClick={() => {
                            window.scrollTo({top: 0, behavior: 'smooth'})
                        }}
                        onMouseEnter={() => {
                            if (srRef.current) {
                                srRef.current.textContent = ''
                                setTimeout(() => {
                                    srRef.current.textContent = intl.formatMessage({
                                        id: 'accessibility.scroll_to_top',
                                        defaultMessage: 'Scroll to top'
                                    })
                                }, 50)
                            }
                        }}
                        direction="column"
                        color="#ff5d00"
                        lineHeight="16px"
                        fontWeight="bold"
                        textTransform="uppercase"
                        aria-label={intl.formatMessage({
                            id: 'accessibility.scroll_to_top',
                            defaultMessage: 'Scroll to top'
                        })}
                    >
                        <TopArrowIcon aria-hidden="true" />
                        <Box as="span" aria-hidden="true">
                            {intl.formatMessage({id: 'go.to_top', defaultMessage: 'Top'})}
                        </Box>
                    </Flex>

                    {/*Screen Reader Live Region */}
                    <Box
                        ref={srRef}
                        id="sr-hover-announcer"
                        aria-live="polite"
                        aria-atomic="true"
                        position="absolute"
                        width="1px"
                        height="1px"
                        margin="-1px"
                        overflow="hidden"
                        clip="rect(0 0 0 0)"
                        whiteSpace="nowrap"
                        border="0"
                    />
                </Box>
            </Flex>
        )
    )
}

export default ScrollToTop
